<div class="login_form">
  <div class="text-center mb-4 pb-2">
    <p class="">Welcome To</p>
    <h1 class="tenMT">DeliveryPal</h1>
  </div>
  <div class="alert text-center mb-3" [ngClass]="alertClass" *ngIf="apiResponse">
    {{ alertText }}
    <mat-icon (click)="apiResponse = false">close</mat-icon>
  </div>
  <form [formGroup]="passForm">
    <div class="field-row">
      <mat-form-field appearance="outline">
        <mat-label>Enter new password</mat-label>
        <input matInput type="password" formControlName="password" />
        <mat-error *ngIf="passForm.get('password').errors?.required && submitted">Required</mat-error>
        <mat-error *ngIf="passForm.get('password').errors?.minlength && submitted">Please enter at least 6
          characters</mat-error>
      </mat-form-field>
    </div>
    <div class="field-row">
      <mat-form-field appearance="outline">
        <mat-label>Enter confirm password</mat-label>
        <input matInput type="password" formControlName="confirmPassword" />
        <mat-error *ngIf="passForm.get('confirmPassword').errors?.required && submitted">Required</mat-error>
        <mat-error *ngIf="
            passForm.get('confirmPassword').errors?.mismatch &&
            passForm.get('confirmPassword').dirty &&
            submitted
          ">Passwords do not match.</mat-error>
      </mat-form-field>
    </div>
    <div class="d-flex justify-content-center">
      <button mat-flat-button color="primary" class="login-btn" (click)="onSubmit()">
        Reset
      </button>
    </div>
  </form>
  <div class="text-center"></div>
</div>